<div class="sucesso__logo">
  <img src="assets/img/logos/safra.svg" />
</div>
<div *ngIf="payments && !origemCanal" class="sucesso">
  <div class="page-status">
    <div class="page-status__info">
      <span class="page-status__icon-success"></span>

      <h2 class="page-status__title">Pagamento autorizado com sucesso</h2>

      <p class="page-status__description">Pagamento autorizado com sucesso e você será redirecionado para a instituição
        iniciadora do pagamento com segurança.</p>
    </div>

    <div class="page-status__buttons">
      <div class="sucesso__box-lock" buttons>
        <span class="page-status__icon-lock"></span>
        <p>Você está em um ambiente seguro.</p>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!payments" class="sucesso">
  <div class="page-status">
    <div class="page-status__info">
      <span class="page-status__icon-success"></span>

      <h2 class="page-status__title">Dados compartilhados</h2>

      <p class="page-status__description">Os dados solicitados foram compartilhados com sucesso e você será
        redirecionado para a instituição de início com segurança.</p>
    </div>

    <div class="page-status__buttons">
      <div class="sucesso__box-lock" buttons>
        <span class="page-status__icon-lock"></span>
        <p>Você está em um ambiente seguro.</p>
      </div>
    </div>
  </div>
</div>
<div *ngIf="origemCanal" class="sucesso">
  <div class="page-status">
    <div class="page-status__info">
      <span class="page-status__icon-success"></span>

      <h2 class="page-status__title">Pagamento autorizado com sucesso</h2>

      <p class="page-status__description">Pagamento autorizado com sucesso! Em instantes você será redirecionado para a
        instituição iniciadora do pagamento
        com segurança a partir da página onde leu o QRCode em seu outro dispositivo.</p>
    </div>

    <div class="page-status__buttons">
      <div class="sucesso__box-lock" buttons>
        <span class="page-status__icon-lock"></span>
        <p>Você está em um ambiente seguro.</p>
      </div>
    </div>
  </div>
</div>